import {apiClient} from './axios';
import {BaseResponse} from "../models/baseResponse.ts";

export interface UserProfile {
    id: number;
    email: string;
    nickName: string;
}

export const authApi = {
    // Firebase 토큰 검증 및 사용자 정보 가져오기
    verifyFirebaseToken: async (firebaseToken: string) => {
        return apiClient.post<BaseResponse<UserProfile>>('/auth/verify-firebase', {
            firebaseToken,
        });
    },
};
